import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { clearToken } from "../redux/authSlice";
import {
  removeGarmentRemarks,
  removeLocalAppServices,
  removeLocalPackageBooking,
  removeLocalServiceUnit,
  removeLocalPriceCode,
  removeSelectedDocsSchedule,
  removeUserData,
  removeLocalGarmentRemarksPriority,
  removeLocalChargesAndDiscount,
  removeLocalStorePaymentGatewayConfig,
  removeLocalPaymentMode,
  removeLocalStoreDefaultPrice,
  removeLocalFranchiseRate,
  removeLocalFranchiseStore,
  removeLocalFranchiseUserInfo,
  removeLocalFranchiseInfo,
  removeLocalAdminSelectedStore,
  removeNextPickupTime,
  removeLocalGarmentPack,
  removeStoreLocalData,
  removeHostProfile,
  removeSystemSchedular
} from "../utils/localStorage";

export default function Logout() {
  const accessToken = useSelector((state) => state.auth.accessToken);
  const dispatch = useDispatch();

  useEffect(() => {
    removeUserData();
    removeSelectedDocsSchedule();
    removeGarmentRemarks();
    removeLocalServiceUnit();
    removeLocalAppServices();
    removeLocalStoreDefaultPrice();
    removeLocalPaymentMode();
    removeLocalStorePaymentGatewayConfig();
    removeLocalChargesAndDiscount();
    removeLocalGarmentPack();
    removeLocalFranchiseUserInfo();
    removeLocalFranchiseStore();
    removeLocalFranchiseRate();
    removeLocalFranchiseInfo();
    removeLocalPriceCode();
    removeLocalAdminSelectedStore();
    // removeNextPickupTime();
    removeLocalPackageBooking();
    removeLocalGarmentRemarksPriority();
    removeStoreLocalData();
    removeHostProfile();
    removeSystemSchedular();
    dispatch(clearToken());
  }, []);

  return !accessToken ? (
    <Navigate to={"/login"} replace />
  ) : (
    <p>You are being logout</p>
  );
}
